import React, { useState, useEffect } from 'react'
import { useShared } from '../../hooks/useShared'
import MainSection from '../../components/sections/MainSection';
import { ToastContainer } from 'react-toastify';
import AIcon from '../../components/partials/AIcon';


const breadcrumbs = [{ name: 'آرشیف', link: '/archives' }]


const searchInputFields = [
    { label: 'doc_list', name: 'getArchiveCountByType', type: 'text', roles: [1], icon: 'text-outline', className: '', hide: true },
    { label: 'نوعيت مکتوب', name: 'doc_type', type: 'select', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', options: [] },
    { label: 'زون', name: 'zone', type: 'select', roles: [1,2], icon: 'text-outline', className: 'md:col-span-2', options: []},
    { label: 'عنوان', name: 'name', type: 'text', roles: [1,2,19], icon: 'text-outline', className: 'md:col-span-2', },

];


export default function Archives() {
    const { models, auth, navigate } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1, 2, 19])) {
            return navigate("/db/notAllowed")
        }
    }, [])



    const gotoListage = (m) => {
        navigate(`/db/archives/list_archive/${m}`)
    }


    const getList = () => {
        console.log("test model: ", models)
        return (
            <div className="grid grid-col-2 md:grid-cols-8 mt-4 grid-flow-col ">
                {models?.data?.map((m, i) => (
                    <div key={i} className="text-center cursor-pointer hover:bg-main-color/10 rounded-lg m-2 border " onClick={() => gotoListage(m?.doc_type?.value)}>
                        <AIcon name="folder-open-sharp" size={50} className='!text-yellow-700 ' />
                        <div>{m?.doc_type?.label}</div>
                        <div>({m?.count})</div>
                    </div>
                ))}
            </div>
        )
    }


    return (
        <>
            <MainSection v={{
                searchInputFields,
                newModelInputFields: [{ test: "new page" }],
                breadcrumbs,
                addNewItemTitle: "آپلود فایل جديد",
                tableTitle: 'ليست ارشيف',
                url: "archives",
                modelName: 'Archives',
                modelScreen: '',
                newModelDialogClassName: "h-[90%]",
                list: getList(),
                mUrl: { delete: 'archives', create: 'archives', getAll: 'archivesAdvanceSearch' },
                searchData: { getArchiveCountByType: true }
            }} />

            <ToastContainer />
        </>
    )
}
